<template>
	<v-row
		dense
		no-gutters
		justify = "center"
		align   = "center"
	>
		<v-col
			xl 	 = "12"
			lg 	 = "12"
			md 	 = "12"
			sm 	 = "12"
			xs 	 = "12"
			cols = "12"
		>
			<v-card 
				outlined				
			>
				<v-card-title
					class = "grey secondary subtitle-1 pa-0 body- white--text justify-center"
				>
					<v-icon
						
						color  = "success"
						v-text = "'mdi-vector-intersection'" 
						class  = "mx-2"
					></v-icon>

					<span
						class ="text-uppercase"
						v-text = "$ml.get(head.title)"
					></span>
					<!-- <v-chip 
						small 
						color  = "success"
						class  = "mx-2 text-uppercase"
						v-show = "head.title1"
					>  {{ head.title1 }} </v-chip> -->


					<!-- <v-spacer></v-spacer> -->
					
					<v-icon 
						small 
						color 	= "white"
						class 	= "ml-1"
						@click 	= "$router.back()"
						v-show  = "false" 
					>
						mdi-arrow-left-circle
					</v-icon>
					
				
				</v-card-title>
				<v-card-text
					class = "pt-1 pa-1"
				>
					<v-row>
						
						<v-col 
							cols 	= "4"
							v-show 	= "show.add"
						>
							<v-card 
								outlined

							>
								<v-card-title
									class = "pa-0 pl-2  primary body-2 white--text"
								>
									<span
									>
										{{ sub_title }}										
									</span>
									
									<v-spacer></v-spacer>

								</v-card-title>	
								<v-card-text
									class = "pa-1 "
								>
								<form>
								<v-row
									no-gutters
									justify = "center"
									align 	= "center"
								>	
									<template
										v-for = "(item_field, idx_field) of info_fields "
										
									>			
										
									<!-- v-if  = "item_field.enable"			 -->
										<v-col 
											cols = "11"
											:key = "idx_field"
										>
											<v-text-field
												dense
												outlined
												hide-details
												v-if 		 = "item_field.type == 'text' || item_field.type == 'number' || item_field.type == 'password' "
												v-model 	 = "info[item_field.key]"
												:label  	 = "$ml.get(item_field.text)"
												:type 		 = "item_field.type"
												class 		 = "mt-2"
												v-show 		 = "item_field.enable"
												:placeholder = "item_field.placeholder ? $ml.get(item_field.placeholder) : ''"
												@click 		 = "$Helper.keyboard_is_active(item_field.key, ID_notification, 'obj', 'info', info[item_field.key])"	
												autocomplete        = "false"
											></v-text-field>
												<!-- @input 	= "v => { v = input[item_field.key] }" -->
												<!-- :disabled = "item_field.enable"								 -->
												<!-- @input  = "v => { info[item_field.key] = v.toUpperCase()}"		 -->
											
											<v-select
												dense
												outlined
												hide-details
												v-if 		= "item_field.type == 'select'"
												v-show 		= "item_field.enable"
												:label 		= "$ml.get(item_field.text)"
												v-model 	= "info[item_field.key]"
												:items 		= "render_listeds(item_field.list)"
												:item-text  = "item_field.item_text"
												:item-value = "item_field.value"
												class 		= "my-2"
												@input 		= "render_input(item_field.key)"
											>
												<template v-slot:selection="{ item, index }">
											        <v-chip x-small
											        	v-if = "index < 3">
											          <span>{{ item }}</span>
											        </v-chip>
											        <span
											          v-if  = "index == 4"
											          class = "grey--text caption"
											        >
											          (+{{ info[item_field.key].length - 3 }} others)
											        </span>
											      </template>
											</v-select>

											<v-select
												dense
												outlined
												hide-details
												multiple
												small-chips
												deletable-chips
												v-if 		= "item_field.type == 'multiselect'"
												v-show 		= "item_field.enable"
												:label 		= "$ml.get(item_field.text)"
												v-model 	= "info[item_field.key]"
												:items 		= "render_listeds(item_field.list)"
												class 		= "my-2"
											></v-select>
										</v-col>
									</template>
								</v-row>
								</form>

								<v-expand-transition>
									<v-alert
										v-if   = "info.type_integrate === 'guardian_cloud' && guardian_cloud_errors.length"
										dense
										text
										border = "left"
										color  = "warning"
										class  = "mt-2 mb-0"
										icon   = "mdi-alert-outline"
									>
										<div class="caption font-weight-bold mb-1">{{ $ml.get('alice_api_key_validation_title') }}</div>
										<div
											v-for  = "(err, i) in guardian_cloud_errors"
											:key   = "i"
											class  = "caption"
										>
											<v-icon x-small color="warning" class="mr-1">mdi-circle-small</v-icon>
											{{ $ml.get(err) }}
										</div>
									</v-alert>
								</v-expand-transition>

								<!-- Guardian Cloud: info panel + connection test -->
								<v-expand-transition>
									<v-card
										v-if  = "info.type_integrate === 'guardian_cloud'"
										flat
										outlined
										class = "mt-2 mb-0"
									>
										<v-card-title
											class = "pa-1 px-2 caption font-weight-bold primary white--text"
										>
											<v-icon x-small color="white" class="mr-1">mdi-cloud-check-outline</v-icon>
											{{ $ml.get('guardian_cloud_info_title') }}
										</v-card-title>

										<v-card-text class="pa-2 caption">

											<!-- Formato URL -->
											<div class="font-weight-bold mb-1">
												<v-icon x-small class="mr-1">mdi-link-variant</v-icon>
												{{ $ml.get('guardian_cloud_info_url_label') }}
											</div>
											<v-sheet color="grey darken-3" dark rounded class="pa-2 mb-1" style="font-family:monospace;font-size:11px">
												<span class="green--text">{{ $ml.get('guardian_cloud_info_url_example') }}</span>
											</v-sheet>
											<div class="grey--text mb-3" style="font-size:10px">
												<v-icon x-small color="grey" class="mr-1">mdi-information-outline</v-icon>
												{{ $ml.get('guardian_cloud_info_url_note') }}
											</div>

											<v-divider class="mb-2"></v-divider>

											<!-- Test de conexión -->
											<div class="d-flex align-center mb-2">
												<v-btn
													x-small
													:color   = "guardian_cloud_test.status === 'ok' ? 'success' : 'primary'"
													:loading = "guardian_cloud_test.loading"
													:disabled= "!guardian_cloud_url_valid || guardian_cloud_test.loading"
													@click   = "testGuardianCloudConnection()"
												>
													<v-icon x-small class="mr-1">mdi-connection</v-icon>
													{{ guardian_cloud_test.loading ? $ml.get('guardian_cloud_test_testing') : $ml.get('guardian_cloud_test_btn') }}
												</v-btn>

												<!-- Resultado del test -->
												<div class="ml-2 d-flex align-center" v-if="guardian_cloud_test.status === 'ok'">
													<v-icon small color="success">mdi-check-circle</v-icon>
													<span class="ml-1 success--text font-weight-medium" style="font-size:11px">
														{{ $ml.get('guardian_cloud_test_ok') }}
														<span v-if="guardian_cloud_test.latency_ms" class="grey--text font-weight-regular">
															· {{ guardian_cloud_test.latency_ms }}ms
														</span>
													</span>
												</div>
												<div class="ml-2 d-flex align-center" v-else-if="guardian_cloud_test.status === 'error'">
													<v-icon small color="error">mdi-close-circle</v-icon>
													<span class="ml-1 error--text font-weight-medium" style="font-size:11px">
														{{ $ml.get('guardian_cloud_test_fail') }}
														<span v-if="guardian_cloud_test.error" class="grey--text font-weight-regular">
															({{ guardian_cloud_test.error }})
														</span>
													</span>
												</div>
											</div>

											<!-- Aviso si no fue testeado o si cambió la URL -->
											<v-alert
												v-if   = "!guardian_cloud_test.loading && guardian_cloud_test.status === null && guardian_cloud_url_valid"
												dense
												text
												color  = "info"
												icon   = "mdi-information-outline"
												class  = "mb-0 caption"
											>
												{{ $ml.get('guardian_cloud_test_not_tested') }}
											</v-alert>

										</v-card-text>
									</v-card>
								</v-expand-transition>

								<v-expand-transition>
									<v-alert
										v-if   = "info.type_integrate === 'alice_api_key' && alice_api_key_errors.length"
										dense
										text
										border = "left"
										color  = "warning"
										class  = "mt-2 mb-0"
										icon   = "mdi-alert-outline"
									>
										<div class="caption font-weight-bold mb-1">{{ $ml.get('alice_api_key_validation_title') }}</div>
										<div
											v-for  = "(err, i) in alice_api_key_errors"
											:key   = "i"
											class  = "caption"
										>
											<v-icon x-small color="warning" class="mr-1">mdi-circle-small</v-icon>
											{{ $ml.get(err) }}
										</div>
									</v-alert>
								</v-expand-transition>

								<v-expand-transition>
									<v-alert
										v-if   = "info.type_integrate === 'alice_api_key'"
										dense
										text
										border = "left"
										color  = "info"
										class  = "mt-3 mb-0"
										icon   = "mdi-information-outline"
									>
										<div class="caption font-weight-bold mb-1">{{ $ml.get('alice_api_key_legend_title') }}</div>
										<div class="caption mb-2" style="line-height:1.4">{{ $ml.get('alice_api_key_legend_desc') }}</div>

										<v-row dense no-gutters>
											<v-col cols="12" sm="6" class="pr-sm-2">
												<div class="caption font-weight-bold mb-1">{{ $ml.get('alice_api_key_legend_fields') }}</div>
												<div class="caption mb-1">
													<v-icon x-small color="info" class="mr-1">mdi-identifier</v-icon>
													<span class="font-weight-medium">Client ID —</span>
													{{ $ml.get('alice_api_key_legend_client_id') }}
												</div>
												<div class="caption mb-1">
													<v-icon x-small color="info" class="mr-1">mdi-key</v-icon>
													<span class="font-weight-medium">API Key —</span>
													{{ $ml.get('alice_api_key_legend_api_key') }}
												</div>
												<div class="caption">
													<v-icon x-small color="info" class="mr-1">mdi-shield-check</v-icon>
													<span class="font-weight-medium">Permissions —</span>
													{{ $ml.get('alice_api_key_legend_permissions') }}
												</div>
											</v-col>

											<v-col cols="12" sm="6" class="mt-2 mt-sm-0">
												<div class="caption font-weight-bold mb-1">{{ $ml.get('alice_api_key_legend_examples_title') }}</div>
												<div class="caption mb-1">
													<code style="font-size:10px;word-break:break-all">CLIENT_ID=ag-metrics</code>
												</div>
												<div class="caption mb-1">
													<code style="font-size:10px;word-break:break-all">API_KEY=sk-abc123...</code>
												</div>
												<div class="caption">
													<code style="font-size:10px;word-break:break-all">PERMISSIONS=events:read,media:photos:read</code>
												</div>
											</v-col>
										</v-row>
									</v-alert>
								</v-expand-transition>

								<!-- API docs panel -->
								<v-expand-transition>
									<v-card
										v-if  = "info.type_integrate === 'alice_api_key'"
										flat
										outlined
										class = "mt-2 mb-0"
									>
										<v-card-title
											class  = "pa-1 px-2 caption font-weight-bold primary white--text"
											style  = "cursor:pointer; user-select:none"
											@click = "show.api_docs = !show.api_docs"
										>
											<v-icon x-small color="white" class="mr-1">mdi-book-open-outline</v-icon>
											{{ $ml.get('alice_api_docs_title') }}
											<v-spacer></v-spacer>
											<v-icon x-small color="white">
												{{ show.api_docs ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
											</v-icon>
										</v-card-title>

										<v-expand-transition>
											<v-card-text v-if="show.api_docs" class="pa-2 caption">

												<!-- Auth headers -->
												<div class="font-weight-bold mb-1">
													<v-icon x-small class="mr-1">mdi-shield-key</v-icon>
													{{ $ml.get('alice_api_docs_auth') }}
												</div>
												<v-sheet color="grey darken-3" dark rounded class="pa-2 mb-3" style="font-family:monospace;font-size:10px">
													<div>Authorization: Bearer <span class="yellow--text">{{ info.api_key || '&lt;API_KEY&gt;' }}</span></div>
													<div>X-Client-ID: <span class="cyan--text">{{ info.client_id || '&lt;CLIENT_ID&gt;' }}</span></div>
												</v-sheet>

												<!-- Endpoints -->
												<div class="font-weight-bold mb-1">
													<v-icon x-small class="mr-1">mdi-api</v-icon>
													{{ $ml.get('alice_api_docs_endpoints') }}
													<span class="font-weight-regular grey--text ml-1">
														{{ info.permissions && info.permissions.length ? $ml.get('alice_api_docs_based_on_perms') : $ml.get('alice_api_docs_all') }}
													</span>
												</div>
												<v-sheet color="grey darken-3" dark rounded class="pa-2 mb-1" style="font-family:monospace;font-size:10px">
													<div
														v-for  = "ep in alice_api_key_endpoints"
														:key   = "ep.permission"
														class  = "mb-1 d-flex align-center"
													>
														<span class="blue--text text--lighten-2">{{ ep.method }}</span>
														<span class="ml-1" :class="ep.auth === 'apikey' ? 'green--text' : 'grey--text text--lighten-1'">{{ ep.path }}</span>
														<v-chip
															x-small dark class="ml-2"
															style="font-size:9px;height:14px"
															:color="ep.auth === 'apikey' ? 'green darken-2' : 'orange darken-3'"
														>{{ ep.auth === 'apikey' ? 'API Key' : 'JWT' }}</v-chip>
													</div>
												</v-sheet>
												<div class="caption grey--text mb-3 mt-1">
													<v-icon x-small color="orange darken-3" class="mr-1">mdi-lock</v-icon>
													{{ $ml.get('alice_api_docs_jwt_note') }}
												</div>

												<!-- Ejemplos curl -->
												<v-divider class="my-2"></v-divider>
												<div class="font-weight-bold mb-2">
													<v-icon x-small class="mr-1">mdi-console</v-icon>
													{{ $ml.get('alice_api_docs_example') }}
												</div>

												<!-- Opción A: Snapshot por device -->
												<div class="caption orange--text font-weight-medium mb-1">
													{{ $ml.get('alice_api_docs_option_a') }}
												</div>
												<v-sheet color="grey darken-3" dark rounded class="pa-2 mb-1" style="font-family:monospace;font-size:10px;word-break:break-all">
													<div>curl -X GET \</div>
													<div class="ml-2">"http://&lt;HOST&gt;:9090<span class="green--text">/api/v1/integration/snapshot?device_id=&lt;device_id&gt;&amp;timestamp=&lt;unix_ts&gt;</span>" \</div>
													<div class="ml-2">-H "Authorization: Bearer <span class="yellow--text">{{ info.api_key || '&lt;API_KEY&gt;' }}</span>" \</div>
													<div class="ml-2">-H "X-Client-ID: <span class="cyan--text">{{ info.client_id || '&lt;CLIENT_ID&gt;' }}</span>"</div>
												</v-sheet>

												<!-- Opción B: Evidencia por event UUID -->
												<div class="caption orange--text font-weight-medium mb-1 mt-2">
													{{ $ml.get('alice_api_docs_option_b') }}
												</div>
												<v-sheet color="grey darken-3" dark rounded class="pa-2 mb-1" style="font-family:monospace;font-size:10px;word-break:break-all">
													<div>curl -X GET \</div>
													<div class="ml-2">"http://&lt;HOST&gt;:9090<span class="green--text">/api/v1/events/&lt;event_uuid&gt;/evidence?timestamp=&lt;unix_ts&gt;</span>" \</div>
													<div class="ml-2">-H "Authorization: Bearer <span class="yellow--text">{{ info.api_key || '&lt;API_KEY&gt;' }}</span>" \</div>
													<div class="ml-2">-H "X-Client-ID: <span class="cyan--text">{{ info.client_id || '&lt;CLIENT_ID&gt;' }}</span>"</div>
												</v-sheet>

												<!-- Respuesta -->
												<div class="caption grey--text mb-1 mt-2">{{ $ml.get('alice_api_docs_step1_response') }}</div>
												<v-sheet color="grey darken-4" dark rounded class="pa-2 mb-2" style="font-family:monospace;font-size:10px;word-break:break-all">
													<div>{</div>
													<div class="ml-2">"device_id": <span class="cyan--text">"&lt;uuid&gt;"</span>,</div>
													<div class="ml-2">"evidence": {</div>
													<div class="ml-4">"photo_url": <span class="green--text">"http://&lt;HOST&gt;:9090/api/v1/integration/media/&lt;token&gt;"</span>,</div>
													<div class="ml-4">"video_url": <span class="green--text">"http://&lt;HOST&gt;:9090/api/v1/integration/media/&lt;token&gt;"</span>,</div>
													<div class="ml-4">"expires_in_seconds": <span class="yellow--text">600</span></div>
													<div class="ml-2">}</div>
													<div>}</div>
												</v-sheet>

												<!-- Paso 2: descargar -->
												<div class="caption orange--text font-weight-medium mb-1">
													{{ $ml.get('alice_api_docs_step2') }}
												</div>
												<v-sheet color="grey darken-3" dark rounded class="pa-2" style="font-family:monospace;font-size:10px;word-break:break-all">
													<div class="grey--text mb-1"># {{ $ml.get('alice_api_docs_step2_note') }}</div>
													<div>curl -X GET \</div>
													<div class="ml-2">"http://&lt;HOST&gt;:9090<span class="green--text">/api/v1/integration/media/&lt;token&gt;</span>" \</div>
													<div class="ml-2">--output foto.jpg</div>
												</v-sheet>

											</v-card-text>
										</v-expand-transition>
									</v-card>
								</v-expand-transition>

								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>

									<v-progress-circular
								      	indeterminate
								      	color  = "primary"
								      	v-show = "show_progress"
								    	:size  = "20"
								    	:width = "4"
								    ></v-progress-circular>

									<v-btn
										x-small
										v-show 		= "!show_progress"
										color  		= "primary"
										@click 		= "actions(btn_action)"
										:disabled 	= "!required_info || alice_api_key_errors.length > 0 || guardian_cloud_save_blocked"
									>
										{{ $ml.get(btn_action) }}
									</v-btn>
									<v-btn
										x-small
										color 	  =  "error"
										:disabled = "btn_action == 'update' ? false : true"
										v-text    = "$ml.get('delete')"						
										@click    = "actions('confirm_delete')"
									></v-btn>
								</v-card-actions>
							</v-card>
						</v-col>
						<v-col
							v-show = "show.add"
						>
							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "secondary white--text"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2"
					    		>
					    			{{ $ml.get(head.table_dev) }}
					    		</v-toolbar-title>
					    			
					    	</v-toolbar>
							
							<v-divider></v-divider>

							<v-data-table
								dense
							    fixed-body
							    show-select
							    fixed-header
								class 				 = "elevation-5"
								:items 				 = "devices"
								:headers 			 = "header_table_dev"
								:options.sync 		 = "options_dev"
							   	:server-items-length = "total_dev"
							   	loading-text 		 = "Loading... Please wait"
							   	:loading 			 = "loading_dev"
							    item-key 			 = "id"
							    v-model 			 = "selection_devices"
							    :height  			 = "(layout_height - 200) + 'px'"
							    :single-select  	 = "isSingle_select_dev"
							   	:footer-props  		 = "{
							   		// showFirstLastPage 	: true,
							   		itemsPerPageOptions : [/*15, 30*/],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							   	
							>
								<template
									v-slot:item.create_motion = "{ item, index }"
								>
									<v-btn
										small										
										:color = "item.create_motion ? 'primary' : 'secondary'"
										@click = "actions('set_create_motion', item, index)"
									>
										{{ item.create_motion ? $ml.get("on") : $ml.get("off") }}
									</v-btn>
								</template>
							</v-data-table>
						</v-col>
						<v-col
							cols = "12"
						>

							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "secondary white--text"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2"
					    		>
					    			{{ $ml.get(head.table)}}
					    		</v-toolbar-title>
					    			<v-spacer></v-spacer>
					    			<v-btn
					    				x-small
					    				fab
					    				height 	= "23"
					    				width 	= "25"
					    				:color  = "!show.add ? 'primary' : 'error'"
					    				@click 	= "actions('show')"
					    				v-show 	= "show.add_integration"

					    			>
					    				<v-icon
					    					small
					    					class = "pa-0 ma-0"
					    				>

					    					{{ !show.add ? 'mdi-plus' : 'mdi-close' }} 
					    				</v-icon>
					    			</v-btn>
					    	</v-toolbar>
							
							<v-divider></v-divider>

							<v-data-table
								dense
							    fixed-body
							    fixed-header
								class 				 = "elevation-5"
								:items 				 = "render_list"
								:headers 			 = "header_table"
								:options.sync 		 = "options"
							   	:server-items-length = "total"
							   	loading-text 		 = "Loading... Please wait"
							   	:loading 			 = "loading"
							    item-key 			 = "id"
							    :height  			 = "layout_height + 'px'"
							   	:footer-props  		 = "{
							   		showFirstLastPage 	: true,
							   		itemsPerPageOptions : [15, 30],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							   	
							>
							    <!-- rowsPerPageText: [30] -->
								<template v-slot:item.type_integrate="{ item }">
									<v-chip
										x-small
										:color = "integration_chip_color(item.type_integrate)"
										dark
									>
										<v-icon x-small class="mr-1">{{ integration_chip_icon(item.type_integrate) }}</v-icon>
										{{ item.type_integrate }}
									</v-chip>
								</template>

								<template v-slot:item.details="{ item }">
									<div class="py-1">

										<!-- alice_api_key -->
										<template v-if="item.type_integrate === 'alice_api_key'">
											<div class="caption">
												<v-icon x-small class="mr-1">mdi-identifier</v-icon>
												<span class="font-weight-medium">Client ID:</span> {{ item.client_id || '—' }}
											</div>
											<div class="caption mt-1" v-if="item.permissions">
												<v-icon x-small class="mr-1">mdi-shield-check</v-icon>
												<v-chip
													v-for  = "p in item.permissions.split(',')"
													:key   = "p"
													x-small
													color  = "info"
													text-color = "white"
													class  = "mr-1 mb-1"
												>{{ p.trim() }}</v-chip>
											</div>
										</template>

										<!-- mqtt -->
										<template v-else-if="item.type_integrate === 'mqtt'">
											<div class="caption">
												<v-icon x-small class="mr-1">mdi-lan</v-icon>
												<span class="font-weight-medium">Broker:</span> {{ item.ip_address || '—' }}
												<span v-if="item.port_socket"> : {{ item.port_socket }}</span>
											</div>
											<div class="caption" v-if="item.username">
												<v-icon x-small class="mr-1">mdi-account</v-icon>
												{{ item.username }}
											</div>
										</template>

										<!-- telegramAPI -->
										<template v-else-if="item.type_integrate === 'telegramAPI'">
											<div class="caption">
												<v-icon x-small class="mr-1">mdi-send</v-icon>
												<span class="font-weight-medium">Token:</span>
												{{ item.ip_address ? item.ip_address.slice(0,20) + '…' : '—' }}
											</div>
										</template>

										<!-- guardian_cloud -->
										<template v-else-if="item.type_integrate === 'guardian_cloud'">
											<div class="caption">
												<v-icon x-small class="mr-1">mdi-cloud</v-icon>
												{{ item.ip_address || '—' }}
												<span v-if="item.port_socket"> : {{ item.port_socket }}</span>
											</div>
											<div class="caption" v-if="item.manager_id">
												<v-icon x-small class="mr-1">mdi-tag</v-icon>
												{{ item.manager_id }}
											</div>
										</template>

										<!-- Sera4 -->
										<template v-else-if="item.type_integrate === 'Sera4'">
											<div class="caption">
												<v-icon x-small class="mr-1">mdi-lock</v-icon>
												<span class="font-weight-medium">Site:</span> {{ item.site || '—' }}
											</div>
										</template>

										<!-- default: ip_address based -->
										<template v-else>
											<div class="caption" v-if="item.ip_address">
												<v-icon x-small class="mr-1">mdi-ip-network</v-icon>
												{{ item.ip_address }}
												<span v-if="item.port_socket"> : {{ item.port_socket }}</span>
											</div>
											<div class="caption" v-if="item.manager_id">
												<v-icon x-small class="mr-1">mdi-tag</v-icon>
												{{ item.manager_id }}
											</div>
											<div class="caption" v-if="item.type_encode_media">
												<v-icon x-small class="mr-1">mdi-code-braces</v-icon>
												{{ item.type_encode_media }}
											</div>
											<div class="caption" v-if="!item.ip_address && !item.manager_id">—</div>
										</template>

									</div>
								</template>

								<template v-slot:item.actions="{ item }" >
									<v-btn
										x-small
										color  = "primary"
										@click = "actions('edit', item)"
										v-show = "show.edit_integration"
									>
										<v-icon x-small>mdi-pencil</v-icon>
									</v-btn>
									<v-btn
										x-small
										color  = "error"
										@click = "actions('confirm_delete', item)"
										v-show = "show.delete_integration"
									>
										<v-icon x-small>mdi-delete</v-icon>
									</v-btn>
								</template>

								<template v-slot:item.createdAt="{ item }">
									{{ item.date }}
								</template>
								
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import EventBus from '@/event-bus'
	export default{
		name : 'integration_cloud',
		data : (vm) => ({
			info 	: {},
			input 	: {},
			head 	: {
				title  		: 'integration_config',
				title1 		: 'lpr',
				table  		: 'registered_integrations',
				table_dev 	: 'registered_devices'
			}, 
			info_fields : [
 				{ // 0
					key  		: 'type_integrate',
					text 		: 'type_integrate',
					type 		: 'select',
					list 		: [
						'cloud',
						'module',
						'streaming',
						'guardian_cloud',
						'external_client',
						'mqtt',
						'telegramAPI',
						'Sera4',
						'tecnoparking',
						'ViolationCloud',
						'CitizenFaceAPI',
						'alice_api_key'
					],
					enable 		: true,
					/*value  : '',
					item_text   : ''*/
 				},
				{ // 1
					key  		: 'type_encode_media',
					text 		: 'type_encode_media',
					type 		: 'select',
					list 		: ['base64', 'multipart'],
					enable 		: false,
					/*value  : '',
					item_text   : ''*/
 				},
				{ // 2
					key  		: 'manager_id',
					text 		: 'manager',
					type 		: 'text',
					list 		: "devices",
					enable 		: false,
				},
				
				{ // 3
					key  		: 'ip_address',
					text 		: 'ip_address',
					type 		: 'text',
					enable 		: true,
				},
				{ // 4
					key  		: 'name',
					text 		: 'name',
					placeholder : "name_cloud_msg",

					type 		: 'text',
					enable 		: false,
				},
				{ // 5
					key  		: 'port_socket',
					text 		: 'port_socket',
					placeholder : "port_socket_msg",
					type 		: 'number',
					enable 		: false,
				},
				{ // 6
					key  		: 'name',
					text 		: 'password',
					placeholder : "password",
					type 		: 'password',
					enable 		: false,
				},
				{ // 7
					key  		: 'username',
					text 		: 'username',
					placeholder : "username",
					type 		: 'text',
					enable 		: false,
				},
				{ // 8
					key  		: 'password',
					text 		: 'password',
					placeholder : "password",
					type 		: 'password',
					enable 		: false,
				},
				{ // 9
					key  		: 'site',
					text 		: 'site',
					placeholder : "site",
					type 		: 'text',
					enable 		: false,
				},
				{ // 10
					key  		: 'method',
					text 		: 'method',
					type 		: 'select',
					list 		: ['GET', 'POST','DELETE','PUT'],
					enable 		: false,
				},
				{ // 11
					key  		: 'api_key',
					text 		: 'api_key',
					placeholder : 'api_key',
					type 		: 'text',
					enable 		: false,
				},
				{ // 12
					key  		: 'client_id',
					text 		: 'client_id',
					placeholder : 'client_id',
					type 		: 'text',
					enable 		: false,
				},
				{ // 13
					key  	: 'permissions',
					text 	: 'permissions',
					type 	: 'multiselect',
					list 	: 'alice_api_permissions_list',
					enable 	: false,
				},

			],
			show : {
				add 				: false,
				add_integration 	: true,
				edit_integration 	: true,
				delete_integration 	: true,
				api_docs			: false,
			},
			sub_title : vm.$ml.get('register'),
			
			show_progress : false,
			btn_action 	  : 'save',
			header_table  : [
				{ text: vm.$ml.get('type_integrate'), value: 'type_integrate', align: 'center', width: '130px' },
				{ text: vm.$ml.get('name'),           value: 'name',           align: 'center' },
				{ text: vm.$ml.get('details'),        value: 'details',        align: 'left',   sortable: false },
				{ text: vm.$ml.get('date'),           value: 'createdAt',      align: 'center', width: '130px' },
				{ text: vm.$ml.get('actions'),        value: 'actions',        align: 'center', width: '90px'  }
			],
			header_table_dev  : [
				{ text: vm.$ml.get('name'), value: 'name' },
				{ text: vm.$ml.get('create_motion'), value: 'create_motion' },				
				{ text: vm.$ml.get('type'), value: 'type' },
				// { text: vm.$ml.get('actions'), value: 'actions', align: 'center'}
			],
			options 	  : { itemsPerPage : 30 },
			total 		  : 0,
			layout_height : 400,
			ID_notification : 'listing_details',
			loading 	  : false,
			list_lists 	  : [],
			list 		  : [], 
			required_info : true,
			list_profiles : [],
			bus 		  : {},
			isSingle_select_dev : false,
			selection_devices 	: [],
			options_dev  		: {},
			total_dev   		: 0,
			loading_dev 		: false, 
			list_devs 			: vm.$store.getters["Devices/list"],
			guardian_cloud_test : { status: null, latency_ms: null, error: null, loading: false },

			alice_api_permissions_list : [
				'events:read',
				'media:photos:read',
				'media:videos:read',
				'lpr:read',
				'alerts:read',
				'smart_event:read',
				'face:read',
				'axle:read',
				'counter:read',
				'gps:read',
				'object:read',
				'parking:read',
				'relay_io:read',
			],

		}), // data

		created(){
			if (this.$route.name == 'list_face') {
				this.head.title1 = 'face';
				this.header_table.splice(0, 1, { text : this.$ml.get('entity'), value : 'entity' })
			}
			let obj_new =  this.$Helper.set_property_obj(this.info_fields);
			if (obj_new) {
				this.info = obj_new;
			}
			// this.get_listing()
			// this.get_profiles();

			let modul = this.$store.getters["auth/permission"](this.$route.name || "settings", "", "settings");
			if (modul) {
				if (!modul.can_add ) { this.show.add_integration = false };
				if (!modul.can_edit) { this.show.edit_integration = false };
				if (!modul.can_delete) { this.show.delete_integration = false };
			}
				
		}, // created

		watch : {
			options : {
				handler(){
					this.get_list();
				}, deep : true
			}, // options

			'info.ip_address'(val) {
				if (this.info.type_integrate === 'guardian_cloud') {
					if (this.guardian_cloud_test.status !== null) {
						this.guardian_cloud_test = { status: null, latency_ms: null, error: null, loading: false };
					}
				}
			},

		}, // watch

		computed : {

			alice_api_key_endpoints() {
				const map = {
					'events:read'       : { path: '/api/v1/g/event',              auth: 'jwt' },
					'lpr:read'          : { path: '/api/v1/lpr/event/',           auth: 'jwt' },
					'alerts:read'       : { path: '/api/v1/alerts',               auth: 'jwt' },
					'smart_event:read'  : { path: '/api/v1/smart_event',          auth: 'jwt' },
					'face:read'         : { path: '/api/v1/face/user',            auth: 'jwt' },
					'media:photos:read' : { path: '/api/v1/images',               auth: 'apikey' },
					'media:videos:read' : { path: '/api/v1/record',               auth: 'apikey' },
					'axle:read'         : { path: '/api/v1/axle',                 auth: 'jwt' },
					'counter:read'      : { path: '/api/v1/counter',              auth: 'jwt' },
					'gps:read'          : { path: '/api/v1/gps',                  auth: 'jwt' },
					'object:read'       : { path: '/api/v1/objects',              auth: 'jwt' },
					'parking:read'      : { path: '/api/v1/parking',              auth: 'jwt' },
					'relay_io:read'     : { path: '/api/v1/relay-io-state-history', auth: 'jwt' },
				};
				const selected = Array.isArray(this.info.permissions) && this.info.permissions.length
					? this.info.permissions
					: Object.keys(map);
				return selected.map(p => ({
					permission : p,
					method     : 'GET',
					path       : map[p] ? map[p].path : p,
					auth       : map[p] ? map[p].auth : 'jwt',
				}));
			}, // alice_api_key_endpoints

			guardian_cloud_errors() {
				if (this.info.type_integrate !== 'guardian_cloud') return [];
				const errors = [];
				if (!this.info.ip_address || !String(this.info.ip_address).trim()) {
					errors.push('val_guardian_cloud_url_required');
				} else if (!/^https?:\/\//i.test(String(this.info.ip_address).trim())) {
					errors.push('val_guardian_cloud_url_invalid');
				}
				if (!this.info.name || !String(this.info.name).trim()) {
					errors.push('val_guardian_cloud_name_required');
				}
				return errors;
			}, // guardian_cloud_errors

			guardian_cloud_url_valid() {
				return this.info.type_integrate === 'guardian_cloud'
					&& this.info.ip_address
					&& /^https?:\/\//i.test(String(this.info.ip_address).trim());
			}, // guardian_cloud_url_valid

			guardian_cloud_save_blocked() {
				if (this.info.type_integrate !== 'guardian_cloud') return false;
				if (this.guardian_cloud_errors.length > 0) return true;
				return this.guardian_cloud_test.status !== 'ok';
			}, // guardian_cloud_save_blocked

			alice_api_key_errors() {
				if (this.info.type_integrate !== 'alice_api_key') return [];
				const errors = [];
				if (!this.info.name || !String(this.info.name).trim()) {
					errors.push('val_name_required');
				}
				if (!this.info.client_id || !String(this.info.client_id).trim()) {
					errors.push('val_client_id_required');
				} else if (!/^[a-zA-Z0-9_-]+$/.test(this.info.client_id)) {
					errors.push('val_client_id_invalid');
				}
				if (!this.info.api_key || !String(this.info.api_key).trim()) {
					errors.push('val_api_key_required');
				} else if (this.info.api_key.length < 8) {
					errors.push('val_api_key_too_short');
				}
				if (!this.info.permissions || !this.info.permissions.length) {
					errors.push('val_permissions_required');
				}
				return errors;
			}, // alice_api_key_errors

			render_list : function(){
				return this.list;
			}, // render_list

			devices : function(){
				if (this.list_devs && this.list_devs.length) {
					this.total_dev 	= this.list_devs.length;
				}else {
					this.total_dev 	= 0;
				}
				return this.list_devs;
			}, // devices

		}, // computed

		methods : {
			async testGuardianCloudConnection() {
				this.guardian_cloud_test = { status: null, latency_ms: null, error: null, loading: true };
				try {
					const res = await this.$axios.post(
						this.$URL + '/api/v1/cloud/test-connection',
						{ ip_address: this.info.ip_address }
					);
					this.guardian_cloud_test = {
						status    : res.data.ok ? 'ok' : 'error',
						latency_ms: res.data.latency_ms || null,
						error     : res.data.error || null,
						loading   : false,
					};
				} catch (err) {
					this.guardian_cloud_test = { status: 'error', latency_ms: null, error: err.message, loading: false };
				}
			}, // testGuardianCloudConnection

			integration_chip_color(type) {
				const map = {
					alice_api_key  : 'deep-purple',
					guardian_cloud : 'blue darken-2',
					mqtt           : 'teal',
					telegramAPI    : 'blue',
					cloud          : 'indigo',
					external_client: 'orange darken-1',
					tecnoparking   : 'brown',
					ViolationCloud : 'red darken-1',
					CitizenFaceAPI : 'pink darken-1',
					Sera4          : 'grey darken-1',
					module         : 'cyan darken-1',
					streaming      : 'green darken-1',
				};
				return map[type] || 'secondary';
			},

			integration_chip_icon(type) {
				const map = {
					alice_api_key  : 'mdi-key-variant',
					guardian_cloud : 'mdi-cloud-check',
					mqtt           : 'mdi-lan',
					telegramAPI    : 'mdi-send',
					cloud          : 'mdi-cloud',
					external_client: 'mdi-api',
					tecnoparking   : 'mdi-parking',
					ViolationCloud : 'mdi-alert-circle',
					CitizenFaceAPI : 'mdi-face-recognition',
					Sera4          : 'mdi-lock',
					module         : 'mdi-puzzle',
					streaming      : 'mdi-video',
				};
				return map[type] || 'mdi-vector-intersection';
			},

			actions(act, item, opt) {
				// console.log(" actions integration ", act, item, opt);
				if (act == 'show') {
					this.show.add = !this.show.add;
					if (this.btn_action == 'update' || this.btn_action == 'save') {
						this.actions('clear_info');
					}
				}
				if ( act == 'clear_info') {
					this.btn_action = 'save';
					this.info 		= {};
					this.info_item  = {};
					this.sub_title 	= this.$ml.get('register');
					this.render_input('type_integrate');

				}
				if (act == 'save') {
					this.save();
				}
				if (act == 'update') {
					this.save(true);
				}
				if (act == 'edit') {
					const savedInfo = { ...item };
					if (savedInfo.permissions && typeof savedInfo.permissions === 'string') {
						savedInfo.permissions = savedInfo.permissions.split(',');
					}
					// Call render_input with only type_integrate set so it configures
					// field visibility without deleting already-loaded data
					this.info = { type_integrate: savedInfo.type_integrate };
					this.render_input('type_integrate');
					// Restore all saved data after render_input runs its deletions
					this.info = { ...savedInfo };

					if (item.type_integrate === 'guardian_cloud') {
						this.guardian_cloud_test = { status: 'ok', latency_ms: null, error: null, loading: false };
					} else {
						this.guardian_cloud_test = { status: null, latency_ms: null, error: null, loading: false };
					}

					this.show.add 	= true;
					this.sub_title 	= this.$ml.get('update');
					this.btn_action = 'update';
					this.info_item  = item;
					this.selection_devices = [];

					if (item && item.id) {
						this.$axios.get(this.$URL + '/api/v1/cloud/' + item.id + '/').then(res => {
							if (res.data && res.data.devices && res.data.devices.length > 0) {
								const ids = new Set(res.data.devices.map(d => d.id));
								this.selection_devices = this.list_devs.filter(d => d && ids.has(d.id));
							}
						}).catch(() => {});
					}
				}
				if ( act == 'confirm_delete') {
					this.info_item = { ...item };

					EventBus.$emit('notifications_modal',{
						type  : 'confirm_delete',
						ID 	  : this.ID_notification,
					});
				}else
				if (act == 'set_create_motion') {				
					item.create_motion = !item.create_motion;			
					const idx = this.list_devs.findIndex(x => x && x.id == item.id);
					if (idx >= 0) {
						this.list_devs.splice(idx, 1, {...item});
					}
					
				}
			}, // actions

			render_listeds(list){
				if (this[list]) {
					return this[list];
				}else{
					return list;
				}

			}, // render_list

			get_list(){
				const { itemsPerPage, page } = this.options;
				const api 	 = this.$URL + '/api/v1/cloud/?page=' + page;
				this.loading = true;
				
				this.$axios.get(api).then( res => {
					// console.log(res, 'res get_list');
					let items = res.data.rows;
					if (items && items.length > 0) {
						items.forEach((list_item) =>{
							if (list_item) {
								let temp = this.format_info(list_item);
								if (temp){
									list_item = temp; 
								}
							}
						})
					}
					this.total 	 = res.data.count;
					this.list  	 = [ ...items];
					this.loading = false;

				}).catch( er => {
					this.loading = false;					
					console.log(er, 'Error get_list');
					let  err = er && er.message ? er.message : er;
						

					this.$EventBus.$emit('notifications_modal',{
						type  	: 'error',
						message :  err
					});
				})

			}, // get list
			
			get_listing(){
				
				// const { itemsPerPage, page } = this.options;
				let pg 		= 1;
				let vm 		= this;
				const api 	= this.$URL + '/api/v1/cloud/?page=' + pg;
				// this.loading = true;
				
				this.$axios.get(api).then( res => {
					console.log(res, 'res get_list');
					let items 	  = res.data.rows;
					// this.total = res.data.count;
					let temp_list = [];

					if (items && items.length > 0) {
						items.forEach((item_list) => {
							if (item_list && item_list.name && vm.head.title1 == item_list.type) {
								temp_list.push(item_list);
							}
						})
					}
					console.log(" LISTS : ", temp_list, items)
					if (temp_list && temp_list.length > 0) {

						this.list_lists  	= [ ...temp_list ];
						this.required_info 	= true;
					}else{
						this.$EventBus.$emit('notifications_modal', {
							type 	: 'warning',
							message : ' Required have list created : go to lists'
						})
					}
					// this.loading = false;

				}).catch( er => {
					// this.loading = false;					
					console.log(er, 'Error get_list');
					let err = er && er.message ? er.message : er;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : 'Failed Get de lists : ' + err
					})
				})
			}, // get listing

			save(up){
				if (up) {
					if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_edit", "settings")){
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings"),
						});
						return false;
					};
				}else{
					if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_add", "settings")){
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_create") + " : " + this.$ml.get("settings"),
						});
						return false;
					};
				}
				let opt 	= 'post';
				let info_up = { ...this.info };
				let api 	= this.$URL + '/api/v1/cloud';
				if (Array.isArray(info_up.permissions)) {
					info_up.permissions = info_up.permissions.join(',');
				}
				let check  	= false;
				let msg 	= ''; 
				info_up["devices"] = this.selection_devices;
				if (info_up.type_integrate == "tecnoparking") {
					info_up.type_encode_media 	= "base64";


					if (this.selection_devices && this.selection_devices.length > 0) {
						info_up.manager_id 			= this.selection_devices[0].deviceId;
					}else{
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("req_sel_device"),
						});
						return null;
					}
				}else if(info_up.type_integrate == "ViolationCloud"){
					info_up.type_encode_media 	= "base64";
				}
				if (info_up.type_integrate == "CitizenFaceAPI") {
					info_up.type_encode_media 	= "base64";

				}
				this.loading = true;

				if (up) {
					opt = 'put';					
					msg = 'Not found id'
					if (info_up && info_up.id ) {
						api   += '/' + info_up.id;
						check  = true;
						msg    = '';
					}
				}else{
					check = true;
				}

				/*if (!info_up.listId) {
					check = false;
					msg   = this.$ml.get('require_sel_list')
				}*/
				if (check) {
					this.$axios[opt](api, info_up).then( res => {
						console.log('res ', opt, 'list setting', res );
						this.$EventBus.$emit('notifications_modal',{
							type : up ? 'updated' : 'saved', 
						});
						this.loading = false;
						// this.$router.back();
						if (!up) { // save
							this.total ++;
							let info_res = this.format_info(res.data);
							this.list.push(info_res);
						}else{
							let idx = this.list.indexOf(this.info_item);
							// console.log("update list : ", idx)
							// this.info_item = info_up;
							if (idx >= 0) {
								this.list.splice(idx, 1, info_up);
							}
						}
			    		this.info_fields[2].enable 	= false;
			    		this.selection_devices 		= [];

						if (this.show.add) {
							this.actions('show');
						}
					}).catch(er => {
						this.loading = false;						
						console.log("Error list setting ", opt, er);
						let  err 	 = up ? 'update ' : 'save ';
						err 	 	+= er && er.message ? er.message : er;

						this.$EventBus.$emit('notifications_modal',{
							type  	: 'error',
							message :  err
						});

					})

				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'error',
						message :  msg
					});
					this.loading = false;

				}
			}, // save

			del(item){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_delete", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				if (item) {
					if (item.id) {
						this.loading = true;
						const api 	 = this.$URL + '/api/v1/cloud/' + item.id;
						this.$axios.delete(api).then(res =>{
							this.$EventBus.$emit('notifications_modal',{
								type : 'deleted', 							
							});
							/*let idx = this.list.findIndex(x => (x && x.id == item.id)); // indexOf
							if (idx >= 0) {
								this.list.splice(idx, 1);
							}
							if (this.list && this.list.length === 0) {
								this.total = 0;
							}else{
								this.total = this.list && this.list.length == 1 ? 1 : this.list.length - 1;
							}*/
							this.get_list();
							this.loading   = false;							
							if (this.show.add) {
								this.actions('show');
							}
						}).catch( er => {
							console.log( "Error deleting ", er);
							this.loading = false;
							let  err 	 = up ? 'update ' : 'save ';
							err 		+= er && er.message ? er.message : er;
							this.$EventBus.$emit('notifications_modal',{
								type  	: 'error',
								message :  'Deleting item ' + err
							});
						})
					}else{
						this.$EventBus.$emit('notifications_modal',{
							type  	: 'warning',
							message :  'Item to delete have id'
						});	
					}
				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'warning',
						message :  'Item to delete null'
					});
				}
			}, // del item

			format_info(item){
				if (item){
					if (item.listId) {
						let temp_lists = this.list_lists[this.list_lists.findIndex( x => x.id == item.listId)] ;						
						item.list = temp_lists ? temp_lists.name : false;
						
					}		
					if (item.createdAt) {
						item.date  = this.$momentz(item.createdAt).format('ll, LTS');
					}
					return item;			
				}
				return null
			}, // format info

			render_input(key){
				if (key == 'type_integrate' && this.info[key]){
					console.log("key : ", key,this.info[key])
					this.info_fields[3].text 		= "ip_address";
					this.info_fields[4].text 		= "name";
		    		this.info_fields[3].placeholder	= "name_cloud_msg";
					this.info_fields[5].text 		= "port_socket";
					this.info_fields[5].placeholder = "port_socket_msg"
					this.isSingle_select_dev 		= false;


					if(this.info[key] == 'cloud'){
			    		this.info_fields[1].enable 	= true;
		    			this.info_fields[2].enable  = true;
		    			this.info_fields[4].enable 	= false;
			    		this.info_fields[5].enable 	= false;
			    		this.info_fields[6].enable 	= false;
			    		this.info_fields[7].enable 	= false;			    			
			    		this.info_fields[8].enable 	= false;

			    		delete this.info.name;
						delete this.info.port_socket;
			    	}
			    	else{
			    		this.info_fields[2].enable 	= false;
			    		if (this.info[key] !== 'alice_api_key') {
		    				delete this.info.name;
							delete this.info.port_socket;
							delete this.info.type_encode_media;
							delete this.info.username;
							delete this.info.password;
				    		if (this.info.manager_id) {
				    			delete this.info.manager_id;
				    		}
			    		}
			    		if (["module"].includes(this.info[key])) {
			    			this.info_fields[1].enable 	= true;
			    		}else{
			    			this.info_fields[1].enable 	= false;

			    		}
			    		if (this.info[key] == "guardian_cloud") {
			    			this.info_fields[3].enable 	= true;
			    			this.info_fields[3].placeholder = "guardian_cloud_info_url_example";
			    			this.info_fields[4].enable 	= true;
			    			this.info_fields[5].enable 	= false; // port goes inside ip_address URL
			    			this.info_fields[6].enable 	= false;
			    			this.info_fields[7].enable 	= false;
			    			this.info_fields[8].enable 	= false;

			    		}else 
			    		if (this.info[key] == "external_client"){
			    			this.info_fields[4].enable 	= false;			    			
			    			this.info_fields[5].enable 	= true;
			    			this.info_fields[6].enable 	= true;
			    			this.info_fields[7].enable 	= false;			    			
			    			this.info_fields[8].enable 	= false;
			    			

			    		}else if(this.info[key] == "mqtt"){
			    			this.info_fields[1].enable 	= false;			    			
			    			this.info_fields[2].enable 	= false;			    			
			    			this.info_fields[3].enable 	= true;	 // ip_address		    			
			    			this.info_fields[3].text 	= "broker_address";
			    			this.info_fields[4].enable 	= false;			    		
			    			this.info_fields[5].enable 	= true; // port_socket
			    			this.info_fields[5].text 	= "broker_port";
			    			this.info_fields[5].placeholder = "";
			    			this.info_fields[6].enable 	= false;			    			
			    			this.info_fields[7].enable 	= true;	// 		 username   			
			    			this.info_fields[8].enable 	= true;	// 		 password	    			

			    		}else if(this.info[key] == "telegramAPI"){
			    			this.info_fields[1].enable 	= false;			    			
			    			this.info_fields[2].enable 	= false;			    			
			    			this.info_fields[3].enable 	= true;	 // ip_address		    			
			    			this.info_fields[3].text 	= "telegramAPI";
			    			this.info_fields[4].enable 	= false;			    		
			    			this.info_fields[5].enable 	= false;
			    			this.info_fields[6].enable 	= false;			    			
			    			this.info_fields[7].enable 	= false;			    			
			    			this.info_fields[8].enable 	= false;			    			
			    		}else if(this.info[key] == "Sera4"){
			    			this.info_fields[1].enable 	= false;			    			
			    			this.info_fields[2].enable 	= false;			    			
			    			this.info_fields[3].enable 	= false;	 // ip_address		    			
			    			this.info_fields[3].text 	= "Sera4";
			    			this.info_fields[4].enable 	= false;			    		
			    			this.info_fields[5].enable 	= false;
			    			this.info_fields[6].enable 	= false;			    			
			    			this.info_fields[7].enable 	= false;			    			
			    			this.info_fields[8].enable 	= false;
							this.info_fields[9].enable 	= true;			    			
			    		}else if (this.info[key] == "tecnoparking") {
			    			this.info_fields[1].enable 		= false;			    			
			    			this.info_fields[2].enable 		= false;			    			
			    			this.info_fields[3].enable 		= true;	 // ip_address		 
			    			this.info_fields[3].placeholder	= "ip_address";	 // ip_address		 
			    			this.info_fields[4].enable 		= true;
							this.info_fields[4].placeholder = "name";
							this.isSingle_select_dev 		= true;
							this.selection_devices 			= [];									    		
			    			this.info_fields[5].enable 		= false;
			    			this.info_fields[6].enable 		= false;			    			
			    			this.info_fields[7].enable 		= false;			    			
			    			this.info_fields[8].enable 		= false;


			    		}else if(this.info[key] == "ViolationCloud"){
							this.info_fields[1].enable 		= false;
							this.info_fields[3].enable 		= true;
							this.info_fields[3].placeholder	= "endpoint";
							this.info_fields[4].enable 		= true;
							this.info_fields[4].placeholder = "name";
							this.info_fields[10].enable 	= true;
							this.info_fields[10].placeholder = "method";
							this.info_fields[6].enable 	= false;
							this.info_fields[7].enable 	= false;
							

						}else if (this.info[key] == "CitizenFaceAPI") {
							this.info_fields[1].enable 		= false;
							this.info_fields[3].enable 		= true;
							this.info_fields[3].placeholder	= "endpoint";
							this.info_fields[4].enable 		= false;
							this.info_fields[4].placeholder = "name";
							this.info_fields[8].enable 		= true;
							this.info_fields[8].placeholder = "token";
							this.info_fields[10].enable 	= true;
							this.info_fields[10].placeholder = "method";
						}else if (this.info[key] == "alice_api_key") {
							this.info_fields[1].enable 		= false;
							this.info_fields[3].enable 		= false;
							this.info_fields[4].enable 		= true;
							this.info_fields[4].placeholder = "name";
							this.info_fields[5].enable 		= false;
							this.info_fields[6].enable 		= false;
							this.info_fields[7].enable 		= false;
							this.info_fields[8].enable 		= false;
							this.info_fields[9].enable 		= false;
							this.info_fields[10].enable 	= false;
							this.info_fields[11].enable 	= true;
							this.info_fields[12].enable 	= true;
							this.info_fields[13].enable 	= true;
						}
			    		else{
			    			this.info_fields[4].enable 	= false;
			    			this.info_fields[5].enable 	= false;
			    			this.info_fields[6].enable 	= false;
			    			this.info_fields[7].enable 	= false;			    			
			    			this.info_fields[8].enable 	= false;
			    			
			    		}
			    		
			    	}
				}else{
					// this.info_fields[2].enable = false;
				}
			}

		}, // methods

		mounted(){
			let temp_bus = 'notifications_modal' + this.ID_notification; 
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) => {
				if (action) {
					this.del(this.info_item);
				}
			}); 
			temp_bus = 'keyboard_type' + this.ID_notification;
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					console.log("INPUT TYPE : ",action)
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						if ( action.input || action.input == "") {

							if (type == 'text') {
								if (func == 'toUpperCase') {
									this[key] = action.input[func]();

								}else{
									this[key] = action.input;
								}
							}else{
								// console.log("obj key ", this[obj][key], action.input)
								this[obj][key] = action.input;
								
							}
						}
						 
					}
				}
			});
			temp_bus = 'keyboard_type_button' + this.ID_notification;
			EventBus.$on( temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						// console.log("SEARCH EVENT 1", action.button == "{enter}", type, key)

						if (action.button == '{enter}') {
							if (type == 'text' && key == 'search') {
								// console.log("SEARCH EVENT")
								// this.get_search(this.search);
							}

						}
					}
				}
			})
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(EventBus, this.bus, 'integration_cloud');

		}, // beforeDestroy

	}; // export default
</script>